import React, {useState} from 'react';
import { useAuth } from '../hooks/useAuth';
import { useNavigate } from 'react-router-dom';
import { getAuthErrorMessage } from '../utils/authErrors';
import { 
    FormSectionStyled, 
    FormContainerStyled, 
    InputContainerStyled, 
    InputStyled, 
    LabelStyled,
    ButtonContainerStyled,
    ErrorMessageStyled,
} from '../styles/Form';
import { NavLinkWrapper } from '../styles/Main';
import { PrimaryButtonStyled } from '../styles/Button';


const ResetPassword = () => {
    const navigate = useNavigate();
    const [email, setEmail] = useState('')
    const [error, setError] = useState('')
    const { sendResetPasswordEmail } = useAuth();
    
    const onSubmit = async (e) => {
        e.preventDefault()
        setError('')
        try {
            await sendResetPasswordEmail(email)
            navigate("/resetsent")
        } catch (error) {
            setError(getAuthErrorMessage(error))
            console.log(error.code, error.message);
        }
    }

  return (
    <main>        
        <FormSectionStyled>
            <FormContainerStyled>
                <div style={{ textAlign: 'center', marginBottom: '32px' }}>
                    <h1 style={{ fontSize: '28px', fontWeight: '600', margin: '0 0 8px 0' }}>Reset password</h1>
                    <p style={{ fontSize: '15px', color: '#6b7280', margin: 0 }}>We'll send you a link to reset your password</p>
                </div>
                <form>                                                                                            
                    <InputContainerStyled>
                        <LabelStyled htmlFor="email-address">
                            Email address
                        </LabelStyled>
                        <InputStyled
                            id="email-address"
                            name="email"
                            type="email"
                            autoComplete="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}  
                            required                                    
                            placeholder="Email address"                                
                        />
                    </InputContainerStyled>
                    {error !== '' && <ErrorMessageStyled>{error}</ErrorMessageStyled>}
                                                       
                    <ButtonContainerStyled>
                        <PrimaryButtonStyled
                            type="submit" 
                            onClick={onSubmit}                        
                        >  
                            Send reset link                                
                        </PrimaryButtonStyled>
                    </ButtonContainerStyled>                                         
                </form>
                
                <p>
                    Remember your password?{' '}
                    <NavLinkWrapper to="/signin">
                        Sign in
                    </NavLinkWrapper>
                </p>                   
            </FormContainerStyled>
        </FormSectionStyled>
    </main>
  )
}
 
export default ResetPassword